import { useState, useMemo, useEffect } from "react";
import { Card, Row, Col, Input, Radio, Button, Select, Checkbox, message } from "antd";
import { getUsers } from "../../api/userService";
import RutInput from "../../components/RutInput";
const { TextArea } = Input;
const { Option } = Select;

const glosas = {
  Simple: ({ nombreCompleto, rut }) =>
    `HABIENDOSE ACREDITADO SU IDENTIDAD, FIRMO ANTE MI ${nombreCompleto}, C.I ${rut}. EN PUERTO MONTT, A ${fechaHoyLarga()}, DOY FE`,
  Aval: ({ nombreCompleto, rut }) =>
    `HABIENDOSE ACREDITADO SU IDENTIDAD, FIRMO ANTE MI ${nombreCompleto}, C.I ${rut}, COMO AVALISTA Y CODEUDOR SOLIDARIO. EN PUERTO MONTT, A ${fechaHoyLarga()}, DOY FE`,
  "Cónyuge": ({ nombreCompleto, rut }) =>
    `HABIENDOSE ACREDITADO SU IDENTIDAD, FIRMO ANTE MI ${nombreCompleto}, C.I ${rut}, COMO CONYUGE AUTORIZANTE. EN PUERTO MONTT, A ${fechaHoyLarga()}, DOY FE`,
  "Pagaré": ({ nombreCompleto, rut }) =>
    `HABIENDOSE ACREDITADO SU IDENTIDAD, FIRMO ANTE MI ${nombreCompleto}, C.I ${rut}, COMO SUSCRIPTOR. EN PUERTO MONTT, A ${fechaHoyLarga()}, DOY FE`,
  Finiquito: ({ nombreCompleto, rut }) =>
    `HABIENDOSE ACREDITADO SU IDENTIDAD, LEYO, FIRMO Y RATIFICO ANTE MI ${nombreCompleto}, C.I ${rut}. EN PUERTO MONTT, A ${fechaHoyLarga()}, DOY FE`,
  juridica: ({ representante, empresa, rutEmpresa }) =>
    `HABIENDOSE ACREDITADO SU IDENTIDAD, FIRMO ANTE MI ${representante?.trim() ? representante : "EL REPRESENTANTE"}, EN REPRESENTACION DE ${empresa}, RUT ${rutEmpresa}. EN PUERTO MONTT, A ${fechaHoyLarga()}, DOY FE`,
  poder: ({ representante, nombreCompleto, rut }) =>
    `HABIENDOSE ACREDITADO SU IDENTIDAD, FIRMO ANTE MI ${representante?.trim() ? representante : "EL REPRESENTANTE"}, EN REPRESENTACION DE ${nombreCompleto}, C.I ${rut}, EN VIRTUD DE PODER SUFICIENTE. EN PUERTO MONTT, A ${fechaHoyLarga()}, DOY FE`,
};

function fechaHoyLarga() {
  const meses = [
    "ENERO",
    "FEBRERO",
    "MARZO",
    "ABRIL",
    "MAYO",
    "JUNIO",
    "JULIO",
    "AGOSTO",
    "SEPTIEMBRE",
    "OCTUBRE",
    "NOVIEMBRE",
    "DICIEMBRE",
  ];
  const d = new Date();
  return `${d.getDate()} DE ${meses[d.getMonth()]} DE ${d.getFullYear()}`;
}

const Glossary = () => {
  const [tipoGlosa, setTipoGlosa] = useState("Simple");
  const [rut, setRut] = useState("");
  const [nombres, setNombres] = useState("");
  const [apellidoP, setApellidoP] = useState("");
  const [apellidoM, setApellidoM] = useState("");
  // Jurídica
  const [empresa, setEmpresa] = useState("");
  const [rutEmpresa, setRutEmpresa] = useState("");
  const [repNombres, setRepNombres] = useState("");
  const [repApellidoP, setRepApellidoP] = useState("");
  const [repApellidoM, setRepApellidoM] = useState("");
  const [repRut, setRepRut] = useState("");
  const [hasPower, setHasPower] = useState(false);
  const [personValue, setPersonValue] = useState("natural");
  const [companyValue, setCompanyValue] = useState("undia");
  const [selectedDocs, setSelectedDocs] = useState(["Certificado de administración"]);
  const handlePerson = (e) => {
    const value = e.target.value;
    setPersonValue(value);
    if (value === "natural") {
      setEmpresa("");
      setRutEmpresa("");
      setRepNombres("");
      setRepApellidoP("");
      setRepApellidoM("");
      setRepRut("");
      setSelectedDocs(["Certificado de administración"]);
    } else {
      setHasPower(false);
      setNombres("");
      setApellidoP("");
      setApellidoM("");
      setRut("");
      setRepRut("");
    }
  };

  const nombreCompleto = useMemo(() => {
    const full = `${nombres} ${apellidoP}${apellidoM ? " " + apellidoM : ""}`.trim();
    return full.normalize("NFKD").replace(/[\u0300-\u036f]/g, "").toUpperCase();
  }, [nombres, apellidoP, apellidoM]);

  const representante = useMemo(() => {
    const full = `${repNombres} ${repApellidoP}${repApellidoM ? " " + repApellidoM : ""}`.trim();
    return full.normalize("NFKD").replace(/[\u0300-\u036f]/g, "").toUpperCase();
  }, [repNombres, repApellidoP, repApellidoM]);

  useEffect(() => {
    if (personValue !== "juridica") {
      return;
    }
    if (companyValue === "undia") {
      setSelectedDocs((current) =>
        current.length ? current : ["Certificado de administración"]
      );
    } else if (companyValue === "publica") {
      setSelectedDocs((current) =>
        current.length ? current : ["Certificado de vigencia"]
      );
    }
  }, [companyValue, personValue]);

  const preview = useMemo(() => {
    try {
      if (personValue === "juridica") {
        const cleanEmpresa = (empresa || "").normalize("NFKD").replace(/[\u0300-\u036f]/g, "").toUpperCase();
        const docsText = selectedDocs.length
          ? ` DOCUMENTACION PRESENTADA: ${selectedDocs
              .map((doc) => doc.toUpperCase())
              .join(", ")}.`
          : "";
        const constitucion =
          companyValue === "undia"
            ? " SEGUN CONSTA EN EL REGISTRO DE EMPRESA EN UN DIA."
            : " SEGUN CONSTA EN ESCRITURA PUBLICA PROTOCOLIZADA.";
        return `${glosas.juridica({
          representante,
          empresa: cleanEmpresa,
          rutEmpresa: rutEmpresa || rut,
        })}${constitucion}${docsText}`;
      }
      if (hasPower) {
        return glosas.poder({ representante, nombreCompleto, rut });
      }
      const builder = glosas[tipoGlosa] || glosas.Simple;
      return builder({ nombreCompleto, rut });
    } catch (e) {
      return "";
    }
  }, [personValue, tipoGlosa, nombreCompleto, rut, representante, empresa, rutEmpresa, hasPower, selectedDocs, companyValue]);
  return (
    <>
      <Card title="Generador de Glosas" style={{ margin: 15 }}>
        <Row style={{ marginBottom: 15 }}>
          <Col md={18}>
            <Radio.Group onChange={handlePerson} value={personValue}>
              <Radio value={"natural"}>Persona Natural</Radio>
              <Radio value={"juridica"}>Persona Jurídica</Radio>
            </Radio.Group>
          </Col>
          <Col md={6} style={{ textAlign: 'right' }}>
            <Button 
              onClick={() => {
                setRut("");
                setNombres("");
                setApellidoP("");
                setApellidoM("");
                setEmpresa("");
                setRutEmpresa("");
                setRepNombres("");
                setRepApellidoP("");
                setRepApellidoM("");
                setRepRut("");
                setHasPower(false);
                setPersonValue("natural");
                setCompanyValue("undia");
                setSelectedDocs(["Certificado de administración"]);
                setTipoGlosa("Simple");
                message.success("Campos limpiados");
              }}
              size="small"
            >
              Reset
            </Button>
          </Col>
        </Row>
        <Row gutter={16} style={{ marginBottom: 15 }}>
          <Col md={12}>
            <RutInput 
              value={rut} 
              onChange={(e) => setRut(e.target.value)} 
              onBlur={async () => {
                if (!rut || personValue !== "natural") return;
                try {
                  // Normalizar el RUT: remover guiones y puntos para la búsqueda
                  const cleanRut = rut.replace(/[.-]/g, '');
                  const res = await getUsers(1, 1, undefined, cleanRut);
                  const user = res.data?.results?.[0];
                  if (user) {
                    setNombres(user.name || "");
                    setApellidoP(user.firstLastName || "");
                    setApellidoM(user.secondLastName || "");
                  } else {
                    message.warning("RUT no encontrado en la base de datos");
                  }
                } catch (e) {
                  message.error("Error consultando usuarios");
                }
              }} 
            />
          </Col>
          <Col md={12}>
            <span />
          </Col>
        </Row>
        <Row gutter={16}>
          <Col md={8}>
            <Input placeholder={personValue === "natural" ? "NOMBRES" : "RAZON SOCIAL"}
                   value={personValue === "natural" ? nombres : empresa}
                   onChange={(e) => (personValue === "natural" ? setNombres(e.target.value) : setEmpresa(e.target.value))} />
          </Col>
          <Col md={8}>
            {personValue === "natural" ? (
              <Input
                placeholder="APELLIDO PATERNO"
                value={apellidoP}
                onChange={(e) => setApellidoP(e.target.value)}
              />
            ) : (
              <RutInput
                placeholder="RUT EMPRESA"
                value={rutEmpresa}
                onChange={(e) => setRutEmpresa(e.target.value)}
              />
            )}
          </Col>
          {personValue === "natural" && (
            <Col md={8}>
              <Input placeholder="APELLIDO MATERNO" value={apellidoM} onChange={(e) => setApellidoM(e.target.value)} />
            </Col>
          )}
        </Row>
        {personValue === "natural" && (
          <Row gutter={16}>
            <Col style={{ marginTop: 5, marginBottom: 5 }}>
              <Checkbox
                checked={hasPower}
                onChange={(e) => setHasPower(e.target.checked)}
              >
                Agregar Poder
              </Checkbox>
            </Col>
          </Row>
        )}
        {(hasPower || personValue === "juridica") && (
          <>
            <h1>
              Datos {personValue === "juridica" ? "Representante" : "Poder"}
            </h1>
            <Row gutter={16} style={{ marginBottom: 15 }}>
              <Col md={12}>
                <RutInput
                  value={repRut}
                  onChange={(e) => setRepRut(e.target.value)}
                  onBlur={async () => {
                    if (!repRut) return;
                    try {
                      const cleanRut = repRut.replace(/[.-]/g, '');
                      const res = await getUsers(1, 1, undefined, cleanRut);
                      const user = res.data?.results?.[0];
                      if (user) {
                        setRepNombres(user.name || "");
                        setRepApellidoP(user.firstLastName || "");
                        setRepApellidoM(user.secondLastName || "");
                      } else {
                        message.warning("RUT de representante no encontrado");
                      }
                    } catch (error) {
                      message.error("Error consultando representante");
                    }
                  }}
                />
              </Col>
              <Col md={12}>
                <span />
              </Col>
            </Row>
            <Row gutter={16}>
              <Col md={8}>
                <Input placeholder="Nombres" value={repNombres} onChange={(e) => setRepNombres(e.target.value)} />
              </Col>
              <Col md={8}>
                <Input placeholder="Apellido Paterno" value={repApellidoP} onChange={(e) => setRepApellidoP(e.target.value)} />
              </Col>
              <Col md={8}>
                <Input placeholder="Apellido Materno" value={repApellidoM} onChange={(e) => setRepApellidoM(e.target.value)} />
              </Col>
            </Row>
          </>
        )}

        {personValue === "natural" && (
          <>
            <h3 style={{ marginTop: 10 }}>Tipo glosa</h3>
            <Row>
              <Col md={24}>
                <Select
                  style={{ width: "100%" }}
                  placeholder="Seleccione glosa"
                  value={tipoGlosa}
                  onChange={(e) => setTipoGlosa(e)}
                  optionLabelProp="label"
                >
                  <Option value={"Simple"}>Simple</Option>
                  <Option value={"Aval"}>Aval</Option>
                  <Option value={"Cónyuge"}>Conyuge</Option>
                  <Option value={"Pagaré"}>Pagare</Option>
                  <Option value={"Finiquito"}>
                    Finiquito o renuncia voluntaria
                  </Option>
                </Select>
              </Col>
            </Row>
          </>
        )}

        {personValue === "juridica" && (
          <>
            <Row gutter={16} style={{ marginBottom: 10, marginTop: 10 }}>
              <Col md={12}>
                <Radio.Group
                  onChange={(e) => setCompanyValue(e.target.value)}
                  value={companyValue}
                >
                  <Radio value={"undia"}>Empresa en un día</Radio>
                  <Radio value={"publica"}>Convencional</Radio>
                </Radio.Group>
              </Col>
            </Row>
            <Row>
              <h3>Documentos acreditación</h3>
              <Col md={24}>
                <Select
                  mode="multiple"
                  allowClear
                  style={{ width: "100%" }}
                  placeholder="Seleccione documentos"
                  value={selectedDocs}
                  onChange={(values) => setSelectedDocs(values)}
                  optionLabelProp="label"
                >
                  <Option value={"Certificado de administración"}>
                    Certificado de administración
                  </Option>
                  <Option value={"Certificado de vigencia"}>
                    Certificado de vigencia
                  </Option>
                </Select>
              </Col>
            </Row>
          </>
        )}
        <Row>
          <h3 style={{ marginTop: 10 }}>Previsualización</h3>
          <Col xs={24} md={24}>
            <TextArea 
              rows={4} 
              value={preview} 
              onChange={() => {}} 
              style={{ marginBottom: 8 }}
            />
            <Button
              type="primary"
              onClick={() => message.success("Glosa lista para imprimir")}
              block
              style={{ marginBottom: 8 }}
            >
              Imprimir
            </Button>
            <Button
              onClick={() => {
                navigator.clipboard.writeText(preview).then(() => {
                  message.success("Glosa copiada al portapapeles");
                }).catch(() => {
                  message.error("Error al copiar al portapapeles");
                });
              }}
              block
            >
              Copiar al Portapapeles
            </Button>
            <div style={{ 
              marginTop: 8, 
              fontSize: '12px', 
              color: '#666', 
              textAlign: 'center'
            }}>
              Glosa generada según datos ingresados. Revise la previsualización antes de copiar o imprimir.
            </div>
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default Glossary;
